import React, { useCallback, useContext, useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ProductContext } from "../../../store";
import { getAiVisibilityReport } from "../../../services/aiVisibilityApi";
import DetailSkeleton from "../../../components/Skeleton/DetailSkeleton";
import AiVisibilityRecommendationView from "../../../components/AiVisibility/AiVisibilityRecommendationView";
import LoadingState from "../../../components/AiVisibility/Report/LoadingState";
import ErrorState from "../../../components/AiVisibility/Report/ErrorState";
import EmptyState from "../../../components/AiVisibility/Report/EmptyState";
import { parseAuditIdParam } from "../../../utils/auditIdUtils";

const AiVisibilityRecommendationViewPage = () => {
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const auditId = parseAuditIdParam(searchParams.get("auditId"));
	const { currentWebsiteId, userLoader, websiteLoader } = useContext(ProductContext);
	const [report, setReport] = useState(null);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);

	const loadReport = useCallback(async () => {
		if (!currentWebsiteId || auditId == null) {
			setLoading(false);
			return;
		}
		setLoading(true);
		setError(null);
		const result = await getAiVisibilityReport(currentWebsiteId, auditId);
		setLoading(false);
		if (!result.ok) {
			setError(result.message || "Failed to load recommendations");
			setReport(null);
			return;
		}
		setReport(result.report);
	}, [currentWebsiteId, auditId]);

	useEffect(() => {
		if (userLoader || websiteLoader) return;
		if (auditId == null) {
			navigate("/aivisibility/recommendations", { replace: true });
			return;
		}
		if (!currentWebsiteId) return;
		loadReport();
	}, [currentWebsiteId, auditId, loadReport, navigate, userLoader, websiteLoader]);

	if (userLoader || websiteLoader) {
		return <DetailSkeleton />;
	}

	if (loading) {
		return <LoadingState title="Loading Recommendations" message="Fetching your AEO and GEO recommendations..." />;
	}

	if (error) {
		return (
			<ErrorState
				message={error}
				onRetry={loadReport}
			/>
		);
	}

	if (!report) {
		return <EmptyState />;
	}

	return <AiVisibilityRecommendationView report={report} />;
};

export default AiVisibilityRecommendationViewPage;
